export enum AgeConfirmationEnum {
  CONFIRMED = 'confirmed',
  NOT_CONFIRMED = 'not-confirmed',
}
